import { UserAccess } from '@core/authorization/user-access';
import { IGlobals } from '@shared/interfaces/globals';

export let Globals: IGlobals = {
    CurrentUser: null,
    UAC: new UserAccess(),
    AppDialogs: null,
    ReportingDialogs: null,
    PermittingDialogs: null,
    TimeZoneDescription: '',
    LoggedInUserCount: 0,
    ShowProcessing: null,
    HideProcessing: null
};
